import { GET_MAINTENANCE_STATUS } from "graphql/queries";
import { useLazyQueryWithCallbacks } from "helpers/hooks/useQueryCustom";
import { useEffect } from "react";
interface ICheckMaintenanceProps {
  setMaintenance: (state: boolean) => void;
  setLoadingPage: (state: boolean) => void;
}

const CheckMaintenance: React.FC<ICheckMaintenanceProps> = ({
  setMaintenance,
  setLoadingPage,
})=> {
  const pathName = window.location.pathname;
  const [getMaintenanceStatus] = useLazyQueryWithCallbacks(GET_MAINTENANCE_STATUS, {
    onCompleted: (data: any) => {
      if (data.getMaintenanceStatus.responseCode === 0) {
        setMaintenance(data.getMaintenanceStatus.isUnderMaintenance);
        setLoadingPage(false);
      } else {
        setLoadingPage(false);
      }
    },
    onError: () => {
      setLoadingPage(false);
    },
  });

  useEffect(() => {
    if (pathName !== "/auth/401") {
      getMaintenanceStatus();
    } else {
      setLoadingPage(false);
    }
  }, [getMaintenanceStatus, pathName, setLoadingPage]);

  return <></>;
};

export default CheckMaintenance;
